import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getUserStatuses} from 'src/openapi/admin/apis/GetUserStatusesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectUserStatuses} from './services/dictionary-slice';

export const useUserStatuses = () => {
    const apiDispatch = useAppDispatch();
    const userStatuses = useSelector(selectUserStatuses);

    const loadUserStatuses = useCallback(() => {
        if (!userStatuses.length) {
            apiDispatch(getUserStatuses());
        }
    }, [userStatuses.length, apiDispatch]);

    const getUserStatusByCode = useCallback((code: string) => {
        return userStatuses.find(e => e.code === code);
    }, [userStatuses]);

    return {userStatuses, loadUserStatuses, getUserStatusByCode};
};
